import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'confirm/:id',
  component: generateAsyncRouteComponent({
    loader: () => import('./components/OrderConfirmationPageContainer'),
  }),
};
